module.exports = __webpack_public_path__ + "img/goods13_6.590014b2.jpg";